module.exports = __webpack_public_path__ + "static/media/anmol.1ea2f5d1.jpg";